/* eslint-disable */
import COLORS from '../../utils/constants/colors';

const HALF_CIRCLE_ANGLE = 180;
const FULL_CIRCLE_ANGLE = 360;

export const extendedMaps = maps => {
  const extendedMaps = maps;
  // eslint-disable-next-line func-names
  extendedMaps.Polyline.Shape = function(
    map,
    point,
    r1,
    r2,
    r3,
    r4,
    rotation,
    vertexCount,
    colour,
    weight,
    opacity,
    tilt,
    id,
    layer,
  ) {
    const rot = (-rotation * Math.PI) / 180;
    const points = [];
    let flop = -1,
      I1;

    const latConv =
      maps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat() + 0.1, point.lng()),
      ) * 10;
    const lngConv =
      maps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat(), point.lng() + 0.1),
      ) * 10;
    const step = 360 / vertexCount || 10;
    if (tilt) {
      I1 = 360 / vertexCount;
    } else {
      I1 = 0;
    }
    for (let i = I1; i <= 360.001 + I1; i += step) {
      const r1a = r2;
      const r2a = r1;
      flop = -1 - flop;
      const y = r1a * Math.cos((i * Math.PI) / 180);
      const x = r2a * Math.sin((i * Math.PI) / 180);
      const lng = (x * Math.cos(rot) - y * Math.sin(rot)) / lngConv;
      const lat = (y * Math.cos(rot) + x * Math.sin(rot)) / latConv;

      points.push(new maps.LatLng(point.lat() + lat, point.lng() + lng));
    }
    return new maps.Polyline({
      id,
      layer,
      path: points,
      strokeColor: colour,
      strokeWeight: 1,
      map,
      strokeOpacity: 1,
      geodesic: false,
      icons: [
        {
          icon: {
            strokeColor: colour,
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 1,
            strokeWeight: 2,
          },

          offset: '0',
          repeat: '7px',
        },
      ],
    });
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polyline.Ellipse = function(
    map,
    point,
    r1,
    r2,
    rotation = 0,
    colour,
    weight,
    opacity,
    id,
    layer,
  ) {
    return extendedMaps.Polyline.Shape(
      map,
      point,
      r1,
      r2,
      r1,
      r2,
      rotation,
      100,
      colour,
      weight,
      opacity,
      undefined,
      id,
      layer,
    );
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polygon.Ellipse = function({
    point,
    r1,
    r2,
    rotation = 0,
    strokeColour,
    strokeWeight,
    strokeOpacity,
    fillColour,
    fillOpacity,
    opts,
    draggable,
    vertex = 100,
    tilt = 0,
    id,
    layer,
  }) {
    return extendedMaps.Polygon.Shape(
      point,
      r1,
      r2,
      r1,
      r2,
      rotation,
      vertex,
      strokeColour,
      strokeWeight,
      strokeOpacity,
      fillColour,
      fillOpacity,
      opts,
      draggable,
      tilt,
      id,
      layer,
    );
  };
  // eslint-disable-next-line func-names
  extendedMaps.calculateEllipsePoints = function(
    point,
    r1,
    r2,
    r3,
    r4,
    rotation,
    vertexCount,
    tilt,
  ) {
    const rot = (-rotation * Math.PI) / 180;
    const points = [];
    const latConv =
      maps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat() + 0.1, point.lng()),
      ) * 10;
    const lngConv =
      maps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat(), point.lng() + 0.1),
      ) * 10;
    const step = FULL_CIRCLE_ANGLE / vertexCount || 10;

    let flop = -1;
    if (tilt) {
      var I1 = HALF_CIRCLE_ANGLE / vertexCount;
    } else {
      var I1 = 0;
    }
    for (let i = I1; i <= FULL_CIRCLE_ANGLE + I1; i += step) {
      const r1a = flop ? r1 : r3;
      const r2a = flop ? r2 : r4;
      flop = -1 - flop;
      const y = r1a * Math.cos((i * Math.PI) / HALF_CIRCLE_ANGLE);
      const x = r2a * Math.sin((i * Math.PI) / HALF_CIRCLE_ANGLE);
      const lng = (x * Math.cos(rot) - y * Math.sin(rot)) / lngConv;
      const lat = (y * Math.cos(rot) + x * Math.sin(rot)) / latConv;

      points.push(new maps.LatLng(point.lat() + lat, point.lng() + lng));
    }

    return points;
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polygon.Shape = function(
    point,
    r1,
    r2,
    r3,
    r4,
    rotation,
    vertexCount,
    strokeColour,
    strokeWeight,
    strokeOpacity,
    fillColour,
    fillOpacity,
    opts,
    draggable,
    tilt,
    id,
    layer,
  ) {
    const points = extendedMaps.calculateEllipsePoints(
      point,
      r1,
      r2,
      r3,
      r4,
      rotation,
      vertexCount,
      tilt,
    );

    return new maps.Polygon({
      paths: points,
      strokeColor: strokeColour,
      strokeWeight: strokeWeight,
      strokeOpacity: strokeOpacity,
      fillColor: fillColour,
      fillOpacity: fillOpacity,
      draggable,
      id,
      layer,
    });
  };

  // RODO: REFACTOR
  /// eslint-disable-next-line func-names
  extendedMaps.Polygon.prototype.redrawEllipse = function(
    point,
    r1,
    r2,
    r3,
    r4,
    rotation,
    vertexCount = 100,
    tilt,
  ) {
    const points = extendedMaps.calculateEllipsePoints(
      point,
      r1,
      r2,
      r3,
      r4,
      rotation,
      vertexCount,
      tilt,
    );
    this.setPaths(points);
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polygon.prototype.rotate = function(
    angle,
    latLng,
    map = this.getMap(),
  ) {
    if (map === undefined) {
      console.warn('No valid google maps object found');
      return;
    }

    var coords = this.getPath().getArray();
    var projection = map.getProjection();
    var origin = projection.fromLatLngToPoint(latLng);
    coords.forEach(function(point, index) {
      var pixelCoord = projection
        .fromLatLngToPoint(point)
        .rotate(angle, origin);
      coords[index] = projection.fromPointToLatLng(pixelCoord);
    });

    this.setPaths(coords);
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polygon.prototype.getCenter = function() {
    var coords = this.getPath().getArray();

    var bounds = new maps.LatLngBounds();

    coords.forEach(function(point, index) {
      bounds.extend(coords[index]);
    });

    return bounds.getCenter();
  };
  // eslint-disable-next-line func-names
  extendedMaps.LatLng.prototype.distanceTo = function(point) {
    var lat = Math.pow(this.lat() - point.lat(), 2);
    var lng = Math.pow(this.lng() - point.lng(), 2);

    return Math.sqrt(lat + lng);
  };
  // eslint-disable-next-line func-names
  extendedMaps.Polygon.prototype.distanceAngle = function(
    startPoint,
    endPoint,
  ) {
    const lat1 = startPoint.lat;
    const lng1 = startPoint.lng;
    const lat2 = endPoint.lat;
    const lng2 = endPoint.lng;

    const dLon = lng1 - lng2;
    const y = Math.cos(lat2) * Math.sin(dLon);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    const angle = Math.atan2(x, y) * (180 / Math.PI);
    return angle;
  };
  // eslint-disable-next-line func-names
  extendedMaps.LatLng.prototype.rotate = function(angle, origin) {
    var radianAngle = angle * (Math.PI / 180);

    var radius = this.distanceTo(origin);
    var theta =
      radianAngle +
      Math.atan2(this.lng() - origin.lng(), this.lat() - origin.lat());

    var x = origin.lat() + radius * Math.cos(theta);
    var y = origin.lng() + radius * Math.sin(theta);

    return new maps.LatLng(x, y);
  };
  // eslint-disable-next-line func-names
  extendedMaps.Point.prototype.rotate = function(angle, origin) {
    var rad = angle * (Math.PI / 180);

    var x = this.x - origin.x;
    var y = this.y - origin.y;

    return new maps.Point(
      x * Math.cos(rad) - y * Math.sin(rad) + origin.x,
      x * Math.sin(rad) + y * Math.cos(rad) + origin.y,
    );
  };
  // eslint-disable-next-line func-names
  extendedMaps.CustomHandler = function() {
    this.positions = [];
  };
  // eslint-disable-next-line func-names
  extendedMaps.CustomHandler.prototype.create = function({
    map,
    point,
    angle = 0,
    radiusX,
    radiusY,
  }) {
    for (let i = 0; i < this.handlerAngles.length; i += 1) {
      this.positions.push(
        new maps.Marker({
          position: this.getHandlerPosition({
            angle: this.handlerAngles[i] + angle,
            radiusX,
            radiusY,
            point,
            index: i,
          }),
          map: map,
          draggable: true,
          icon: {
            path: maps.SymbolPath.CIRCLE,
            scale: 4,
            strokeColour: COLORS.BLACK,
            fillColor: COLORS.WHITE,
            fillOpacity: 1,
            strokeWeight: 0.5,
          },
        }),
      );
    }

    return this.positions;
  };
  extendedMaps.CustomHandler.prototype.handlerAngles = [0, 90, 180, -90];
  // eslint-disable-next-line func-names
  extendedMaps.CustomHandler.prototype.setHandlerPosition = function({
    angle,
    radiusX,
    radiusY,
    point,
  }) {
    for (let j = 0; j < this.positions.length; j += 1) {
      const rotatedMarkerPosition = this.getHandlerPosition({
        index: j,
        angle: this.handlerAngles[j] + angle,
        radiusX,
        radiusY,
        point,
      });

      this.positions[j].setPosition(rotatedMarkerPosition);
    }
  };
  // eslint-disable-next-line func-names
  extendedMaps.CustomHandler.prototype.getUnrotatedHandlePosition = function({
    point,
    index,
    radiusX,
    radiusY,
    angle = 0,
  }) {
    const rot = -0;
    const latConv =
      extendedMaps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat() + 0.1, point.lng()),
      ) * 10;
    const lngConv =
      extendedMaps.geometry.spherical.computeDistanceBetween(
        point,
        new maps.LatLng(point.lat(), point.lng() + 0.1),
      ) * 10;

    const handleAngle = this.handlerAngles[index];

    const y = radiusY * Math.cos((handleAngle * Math.PI) / HALF_CIRCLE_ANGLE);
    const x = radiusX * Math.sin((handleAngle * Math.PI) / HALF_CIRCLE_ANGLE);

    const lng = (x * Math.cos(rot) - y * Math.sin(rot)) / lngConv;
    const lat = (y * Math.cos(rot) + x * Math.sin(rot)) / latConv;

    const latLng = new maps.LatLng(point.lat() + lat, point.lng() + lng);

    return latLng.rotate(handleAngle, point);
  };
  // eslint-disable-next-line func-names
  extendedMaps.CustomHandler.prototype.getHandlerPosition = function({
    point,
    index,
    radiusX,
    radiusY,
    angle = 0,
  }) {
    const initialPosition = this.getUnrotatedHandlePosition({
      point,
      index,
      radiusX,
      radiusY,
    });

    const rotatedMarkerPosition = initialPosition.rotate(angle, point);

    return rotatedMarkerPosition;
  };

  return extendedMaps;
};

export const getMarker = (maps, map, shape) => {
  let latLng;

  const infowindow = new maps.InfoWindow();
  if (shape.type == 'polygon') {
    latLng = shape.latLng;
  }
  const marker = new maps.Marker({
    position: latLng,
    map: map,
    draggable: true,
    clickable: true,
    animation: maps.Animation.DROP,
  });
  shape.overlay.marker = marker;
  shape.overlay.bindTo('center', marker, 'position');
  maps.event.addListener(
    marker,
    'click',
    (function(marker) {
      return function() {
        infowindow.setContent('polygon');
        infowindow.open(map, marker);
        // toggleBounce(marker);
      };
    })(marker),
  );
  maps.event.addListener(
    infowindow,
    'closeclick',
    (function(marker) {
      return function() {
        marker.setAnimation(null);
      };
    })(marker),
  );
  return marker;
};
